import { Prices } from '@/store/prices/types';

export type PriceCatalogResponse = {
	currency: string;
	price: number;
	original_price?: number;
	original_tiered_price?: number;
};

export const CURRENCIES_WITHOUT_FRACTIONS = ['jpy', 'clp'];

export const mergeCatalogPriceIntoPrices = (
	priceCatalog: PriceCatalogResponse,
	prices: Prices,
	priceKey: string,
) => {
	// no valid family plan price if the currency doesn't match
	if (priceCatalog.currency.toLowerCase() !== prices.current.currency.toLowerCase()) {
		return prices;
	}

	const price = CURRENCIES_WITHOUT_FRACTIONS.includes(priceCatalog.currency)
		? priceCatalog.price * 100
		: priceCatalog.price;

	return {
		...prices,
		original: {
			...prices.original,
			[priceKey]: price,
		},
		current: {
			...prices.current,
			[priceKey]: price,
		},
	};
};
